interface UserRole {
  name: string;
  merchant: { id: string };
}

export function getUserRole({
  merchantId,
  roles,
}: {
  merchantId: string;
  roles: UserRole[];
}): string {
  const role = roles.find((r) => r.merchant.id === merchantId);
  return role ? role.name : 'unknown';
}
